import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import GuestLayout from '../components/GuestLayout';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContext';
import { Plus, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShopPage() {
  const [products, setProducts] = useState([]);
  const [adding, setAdding] = useState(null);
  const { addToCart } = useCart();
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/products`).then(res => setProducts(res.data)).catch(console.error);
  }, []);

  const handleQuickAdd = async (e, product) => {
    e.stopPropagation();
    if (!token) { navigate('/login'); return; }
    setAdding(product.id);
    const success = await addToCart('product', product.id, 1);
    setAdding(null);
    if (success) toast.success(`${product.title} added to cart`);
  };

  return (
    <GuestLayout>
      <div className="px-6 pt-8 max-w-md mx-auto md:max-w-2xl">
        <div className="mb-6 animate-fade-in">
          <h1 data-testid="shop-title" className="font-heading text-3xl tracking-tight text-espresso">
            Shop the House
          </h1>
          <p className="text-text-muted text-sm mt-1">Take a piece of your stay home with you</p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {products.map((product, idx) => (
            <div
              key={product.id}
              data-testid={`product-card-${product.id}`}
              onClick={() => navigate(`/shop/${product.id}`)}
              className="group cursor-pointer opacity-0 animate-fade-in"
              style={{ animationDelay: `${idx * 0.06}s` }}
            >
              <div className="relative aspect-[3/4] rounded-2xl overflow-hidden mb-3">
                <img
                  src={product.image_url}
                  alt={product.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <button
                  data-testid={`quick-add-${product.id}`}
                  onClick={(e) => handleQuickAdd(e, product)}
                  className="absolute bottom-3 right-3 w-9 h-9 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg transition-transform active:scale-90"
                >
                  {adding === product.id ? (
                    <Loader2 size={16} className="animate-spin text-espresso" />
                  ) : (
                    <Plus size={16} className="text-espresso" />
                  )}
                </button>
                {product.inventory <= 2 && (
                  <span className="absolute top-3 left-3 bg-warmgold text-espresso text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full">
                    Only {product.inventory} left
                  </span>
                )}
              </div>
              <h3 className="font-body text-sm font-semibold text-espresso mb-0.5">{product.title}</h3>
              <p className="text-text-muted text-xs mb-1 line-clamp-1">{product.description}</p>
              <p className="text-espresso font-semibold text-sm">${product.price.toFixed(2)}</p>
            </div>
          ))}
        </div>
      </div>
    </GuestLayout>
  );
}
